import { EmpregadorIdade } from "../dto/empregadorIdade";

export class Empregador {
  public id!: number | string | null;
  public ativo!: boolean;
  public nome!: string;
  public cnpj!: string;
  public parcelaMinima!: number;
  public qtdContratos!: number;
  public validarPor!: string;
  public diaCorte!: number;
  public diaRepasse!: number;
  public diaVencimento!: number;
  public ajustaDU!: boolean;
  public faixaCarencia!: number;
  public dataBaseSim!: Date;
  public dataPrimeiroVencimento!: Date;
  public tamanhoMatricula!: number;
  public codigoExternoBanco!: string;
  public codigoMotor!: string;
  public consultaMargemOnline!: boolean;
  public reservaMargemOnline!: boolean;
  public margemExclusiva!: boolean;
  public matriculaObrigatoria!: boolean;
  public codigoAutorizacaoObrigatorio!: boolean;
  public percentSegurancaRMC!: number;
  public diaCorteFatura!: number;
  public diaCortePrevia!: number;
  public tarifaEmissaoCartao!: number;
  public valorAnuidade!: number;
  public politicaIdade!: boolean;
  public tabelaIdade!: EmpregadorIdade[];
}